import { Component, Input, ViewChild } from '@angular/core';
import { NavController, NavParams, ToastController, PopoverController, AlertController, Checkbox, ModalController, } from 'ionic-angular';
import { GN } from '../../../gn';
import { DIC } from '../../dic';
import * as moment from 'moment';
import { CalendarPage } from '../../calendar/calendar';
import { PopupaddvehiclePage } from './popupaddvehicle';
import { EmployeevehPage } from './employeeveh/employeeveh';


/**
 * Generated class for the DriverseditPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-driversedit',
  templateUrl: 'driversedit.html',
})
export class DriverseditPage {

  @ViewChild('fileImportInput') fileImportInput: any;



  codeInventory = ''
  Title = ''
  DriverId = ''
  Driver: any
  brVozackaDozNumberTel = ''
  codeSappp = ''

  _fullname = ''
  _jobcontract = 0
  _code = ''
  _licensetype = ''
  _ounit = 0
  _puserid = -1
  _DLNumber = ''
  // _borndateDT
  // _firstlicenseDT
  // _DriverslicenseexpirationDT
  _rfid = ''
  // _startincompanyDT
  _clientid = ''

  typelicenceA: boolean = false;
  typelicenceB: boolean = false;
  typelicenceC: boolean = false;
  typelicenceD: boolean = false;
  typelicenceE: boolean = false;

  typegen: boolean = true

  maletoggle: boolean = false;
  femaletoggle: boolean = false;

  driverusertoggle: boolean = false;
  driverprocesstoggle: boolean = false;
  driverdata: boolean = false;

  typelic: boolean = true

  interlicencetoggle: boolean = false
  licencetoggle: boolean = false

  //samo za demo tender
  _nabavkadt = moment().format(this.gn.user.DFormat)

  // _bornDate: any = new Date()
  // _firstlicenseDate: any = new Date()
  // _DriverslicenseexpirationDate: any = new Date()
  // _startincompanyDate: any = new Date()

  // _bornDateStr: any = moment().format('DD-MM-YYYY')
  // _firstlicenseDateStr: any = moment().format('YYYY-MM-DD')
  // _DriverslicenseexpirationDateStr: any = moment().format('YYYY-MM-DD')
  // _startincompanyDateStr: any = moment().format('YYYY-MM-DD')

  // _bornDateYMD: string = ''
  // _firstlicenseDateYMD: string = ''
  // _DriverslicenseexpirationDateYMD: string = ''
  // _startincompanyDateYMD: string = ''


  _bornDate: any = new Date()
  _borndateDT

  _firstlicenseDate: any = new Date()
  _firstlicenseDateDT

  _DriverslicenseexpirationDate: any = new Date()
  _DriverslicenseexpirationDateDT

  _startincompanyDate: any = new Date()
  _startincompanyDateDT


  authemployeess = []
  authemployeessleft = []
  vehiclesid = []
  clubcardsforshow = []
  clubcardsleft = []

  vehDrivers = []
  driveruserpass = {
    clientid: -1,
    driverid: -1,
    id: -1,
    param: null,
    password: '',
    username: '',
    passwordorg: '',
    usernameorg: ''
  }

  permisionvehicle = []


  ipadress: any
  public csvRecords: any[] = [];
  cntforalladdempl = 0
  csvRecordsArray = []
  insideloadertruefalse = 0

  disablerfid = true
  userProcesses = []

  // _cb:any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public toastCtrl: ToastController, public dic: DIC, public popoverCtrl: PopoverController, public alertCtrl: AlertController, public modalCtrl: ModalController,) {
    this.ipadress = window["tfmIP"];

    if (this.gn.user.ClientId == 711 || this.gn.user.ClientId == 357) {
      this.codeInventory = this.dic.l["Inventarenbroj"]
      this.brVozackaDozNumberTel = this.dic.l["telnumber"]
      this.codeSappp = this.dic.l["codeSap"]
    }
    else {
      this.codeInventory = this.dic.l["code"]
      this.brVozackaDozNumberTel = this.dic.l["DLNumber"]
      this.codeSappp = this.dic.l["employeeid"]
    }
    // console.log(gn.Vehicles)
    this.DriverId = navParams.get('driverid')
    // console.log('driverid mi treba',this.DriverId)
    this.Driver = navParams.get('driver')

    //indoor=2 (mebel vi indoor)
    if (this.gn.clientsettings.indoor > 1) {
      var _dat = {
        cid: this.gn.crypt(this.gn.user.ClientId)
      }
      var _that = this
      this.gn._Post('/api/gn/getuserprocess', _dat, function (_data) {
        _that.userProcesses = _data;
        //vraboten vnesen kako del od proces
        if (_that.Driver.indooruserid != -1) {
          _that.driverprocesstoggle = true;
        } else {
          if (_that.gn.clientsettings.allowdriverasuser == '1') {
            _that.driverusertoggle = true;
          }
        }

      })

    }
    // var _cb = navParams.get('cb')
    // this._bornDateYMD = moment(this._bornDate).format('YYYY-MM-DD')
    // this._firstlicenseDateYMD = moment(this._firstlicenseDate).format('YYYY-MM-DD')
    // this._DriverslicenseexpirationDateYMD = moment(this._DriverslicenseexpirationDate).format('YYYY-MM-DD')
    // this._startincompanyDateYMD = moment(this._startincompanyDate).format('YYYY-MM-DD')

    if (this.ipadress == '80.77.159.246' || this.ipadress == '91.98.31.99') {
      this.disablerfid = false
    }

    // this.Title = this.Driver.fullname + '('+this.Driver.code+')'
    if (this.Driver.id == -1) {
      this.Title = this.dic.l["addemployee"]
      this._bornDate = moment(this._bornDate).format(this.gn.user.DFormat)
      this._firstlicenseDate = moment(this._firstlicenseDate).format(this.gn.user.DFormat)
      this._DriverslicenseexpirationDate = moment(this._DriverslicenseexpirationDate).format(this.gn.user.DFormat)
      this._startincompanyDate = moment(this._startincompanyDate).format(this.gn.user.DFormat)

    } else {
      this.Title = this.dic.l["editemployee"]
      this._fullname = this.Driver.fullname
      this._jobcontract = this.Driver.jobcontract
      this._code = this.Driver.code
      this._licensetype = this.Driver.licensetype
      if (this._licensetype.indexOf('A') != -1) {
        this.typelicenceA = true;
      }
      if (this._licensetype.indexOf('B') != -1) {
        this.typelicenceB = true;
      }
      if (this._licensetype.indexOf('C') != -1) {
        this.typelicenceC = true;
      }
      if (this._licensetype.indexOf('D') != -1) {
        this.typelicenceD = true;
      }
      if (this._licensetype.indexOf('E') != -1) {
        this.typelicenceE = true;
      }
      this._ounit = this.Driver.organisationid
      this._puserid = this.Driver.indooruserid
      this._DLNumber = this.Driver.dlnumber
      this._rfid = this.Driver.rfid
      // this._bornDate = moment(this.Driver.borndate).format(this.gn.user.DFormat)
      // this._borndateDT = this.Driver.borndate

      // _that._firstregistration = moment(_that.VehicleData.firstregistration).format(_that.gn.user.DFormat)
      // _that._firstregistrationDT = _that.VehicleData.firstregistration


      this._bornDate = moment(this.Driver.borndate).format(this.gn.user.DFormat)
      this._borndateDT = this.Driver.borndate

      this._firstlicenseDate = moment(this.Driver.firstlicense).format(this.gn.user.DFormat)
      this._firstlicenseDateDT = this.Driver.firstlicense

      this._DriverslicenseexpirationDate = moment(this.Driver.licenseexp).format(this.gn.user.DFormat)
      this._DriverslicenseexpirationDateDT = this.Driver.licenseexp

      this._startincompanyDate = moment(this.Driver.startincompany).format(this.gn.user.DFormat)
      this._startincompanyDateDT = this.Driver.startincompany


      // this._bornDateStr = moment(this._bornDate).format(this.gn.user.DFormat)
      // this._bornDateYMD = moment(this._bornDate).format('YYYY-MM-DD')





      // this._firstlicenseDate = moment(this.Driver.firstlicense).format(this.gn.user.DFormat)
      // this._firstlicenseDT = this.Driver.firstlicense
      // this._firstlicenseDateYMD = moment(this.Driver.firstlicense).format('YYYY-MM-DD')

      // this._DriverslicenseexpirationDate = moment(this.Driver.licenseexp).format(this.gn.user.DFormat)
      // this._DriverslicenseexpirationDT = this.Driver.licenseexp
      // this._DriverslicenseexpirationDateYMD = moment(this.Driver.licenseexp).format('YYYY-MM-DD')

      // this._startincompanyDate = moment(this.Driver.startincompany).format(this.gn.user.DFormat)
      // this._startincompanyDT = this.Driver.startincompany
      // this._startincompanyDateYMD = moment(this.Driver.startincompany).format('YYYY-MM-DD')

      if (this.Driver.gender == 'F') {
        this.toggleGender('female', true)
      } else {
        this.toggleGender('male', true)
      }

      if (this.Driver.interlicense == '0') {
        this.toggleLicense('regular', true)
      } else {
        this.toggleLicense('inter', true)
      }

      this.driveruser()
    }



  }


  fileChangeListener($event: any): void {
    this.cntforalladdempl = 0
    this.csvRecordsArray = []
    this.insideloadertruefalse = 0
    console.log(this.cntforalladdempl, 'this.cntforalladdempl')

    // let text = [];
    let files = $event.srcElement.files;

    if (this.isCSVFile(files[0])) {

      let input = $event.target;
      let reader = new FileReader();
      reader.readAsText(input.files[0]);

      reader.onload = () => {
        let csvData = reader.result;
        // console.log(csvData, 'csvRecordsArray 1')
        this.csvRecordsArray = (<string>csvData).split(/\r\n|\n/)
        // console.log(this.csvRecordsArray, 'this.csvRecordsArray I')
        this.cntforalladdempl = this.csvRecordsArray.length

        var gnloader = false

        //debugger
        for (let i = 0; i < this.csvRecordsArray.length; i++) {
          // this.csvRecordsArray[i].replace(/\/'\'/, '')
          // console.log(this.cntforalladdempl, ' === ', this.csvRecordsArray.length)
          // if (this.cntforalladdempl - 1 == this.csvRecordsArray.length) {
          //   gnloader = true
          // }
          //debugger
          this.csvRecordsArray[i] = this.csvRecordsArray[i].replace(/"/g, "").trim();
          this.csvRecordsArray[i].split(',')
          this.choosefileadd(this.csvRecordsArray[i].split(',')[0], this.csvRecordsArray[i].split(',')[1], this.csvRecordsArray[i].split(',')[2], this.csvRecordsArray[i].split(',')[3], i)
        }
        // str.trim()
        // let this.csvRecordsArray = (<string>csvData).split(/\r\n|\n/);
        // console.log(this.csvRecordsArray, 'this.csvRecordsArray daj da ve vidam')

        // let headersRow = this.getHeaderArray(csvRecordsArray);

        // this.csvRecords = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length);
      };

      reader.onerror = function () {
        alert('Unable to read ' + input.files[0]);
      };

    } else {
      alert("Please import valid .csv file.");
      this.fileReset();
    }
  }


  choosefileadd(imeiprezime, code, pol, rfid, numbercount) {

    var typelicencearr = [];
    if (this.typelicenceA == true) {
      typelicencearr.push('A');
    }
    if (this.typelicenceB == true) {
      typelicencearr.push('B');
    }
    if (this.typelicenceC == true) {
      typelicencearr.push('C');
    }
    if (this.typelicenceD == true) {
      typelicencearr.push('D');
    }
    if (this.typelicenceE == true) {
      typelicencearr.push('E');
    }


    var _dat = {

      fullname: this.gn.crypt(imeiprezime),
      borndate: this.gn.crypt(moment(this._borndateDT).format('YYYY-MM-DD')),


      gender: this.gn.crypt(pol),
      code: this.gn.crypt(code),
      startincompany: this.gn.crypt(moment(this._startincompanyDateDT).format('YYYY-MM-DD')),
      jobcontract: this.gn.crypt(this._jobcontract),
      rfid: this.gn.crypt(rfid),
      licensetype: this.gn.crypt(typelicencearr.join(',')),
      firstlicense: this.gn.crypt(moment(this._firstlicenseDateDT).format('YYYY-MM-DD')),
      licenseexp: this.gn.crypt(moment(this._DriverslicenseexpirationDateDT).format('YYYY-MM-DD')),

      // otherlicense: this._otherlicense,
      organisationid: this.gn.crypt(this._ounit),
      indooruserid: this.gn.crypt(this._puserid),
      // interlicenseexp: this.sadsdasa,
      interlicense: this.interlicencetoggle == true ? this.gn.crypt('1') : this.gn.crypt('0'),
      dlnumber: this.gn.crypt(this._DLNumber),
      // did: this.DriverId,



      driverid: this.gn.crypt(this.DriverId),
      clientid: this.gn.crypt(this.gn.user.ClientId),

      username: (this.gn.clientsettings.allowdriverasuser == '1' && this.driveruserpass.username != '') ? this.gn.crypt(this.driveruserpass.username) : this.gn.crypt('-1'),
      password: (this.gn.clientsettings.allowdriverasuser == '1' && this.driveruserpass.password != '') ? this.gn.crypt(this.driveruserpass.password) : this.gn.crypt('-1')
    }

    // console.log(_dat);
    //this.gn.disableBtn();


    if (numbercount + 1 != this.csvRecordsArray.length) {
      if (this.insideloadertruefalse == 0) {
        this.gn.loadWaiting()
      }
      this.insideloadertruefalse++

    }
    var _that = this

    this.gn._Post('/api/gn/createemployees', _dat, function (_data) {
      if (numbercount + 1 == _that.csvRecordsArray.length) {
        _that.gn.loaderWaiting.dismiss();
        _that.insideloadertruefalse = 0
        var _cb = _that.navParams.get('cb')
        _cb()
        _that.navCtrl.pop()
      }
    })
  }

  // getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any) {
  //   let dataArr = [];
  //   debugger
  //   for (let i = 1; i < csvRecordsArray.length; i++) {
  //     let data = (<string>csvRecordsArray[i]).split(',');

  //     // FOR EACH ROW IN CSV FILE IF THE NUMBER OF COLUMNS
  //     // ARE SAME AS NUMBER OF HEADER COLUMNS THEN PARSE THE DATA
  //     if (data.length == headerLength) {

  //       // var csvRecord = {}
  //       debugger
  //       // data[0].trim();
  //       // csvRecord.name = data[0].trim();
  //       // csvRecord.code = data[1].trim();
  //       // csvRecord.pol = data[2].trim();
  //       // csvRecord.rfid = data[3].trim();


  //       dataArr.push(data[0].trim(), data[1].trim(), data[2].trim(), data[3].trim());
  //     }
  //   }
  //   console.log(dataArr, 'dataArr')
  //   return dataArr;
  // }

  // CHECK IF FILE IS A VALID CSV FILE
  isCSVFile(file: any) {
    return file.name.endsWith(".csv");
  }

  // // GET CSV FILE HEADER COLUMNS
  // getHeaderArray(csvRecordsArr: any) {
  //   let headers = (<string>csvRecordsArr[0]).split(',');
  //   let headerArray = [];
  //   for (let j = 0; j < headers.length; j++) {
  //     headerArray.push(headers[j]);
  //   }
  //   return headerArray;
  // }

  fileReset() {
    this.fileImportInput.nativeElement.value = "";
    this.csvRecords = [];
  }


  toggleLicense(momStr: any, flag: any) {
    if (momStr == 'inter') {
      this.interlicencetoggle = flag;
      this.licencetoggle = !this.interlicencetoggle;
    }
    if (momStr == 'regular') {
      this.licencetoggle = flag;
      this.interlicencetoggle = !this.licencetoggle
    }

  }

  toggleGender(momStr: any, flag: any) {

    if (momStr == 'male') {
      this.maletoggle = flag;
      this.femaletoggle = !this.maletoggle;
    }
    if (momStr == 'female') {
      this.femaletoggle = flag;
      this.maletoggle = !this.femaletoggle
    }

  }

  toggleDriverType(momStr: any, flag: any) {
    // console.log('username ' + this.driveruserpass.username)
    // console.log('puserid ' + this._puserid)
    if (momStr == 'user') {
      this.driverusertoggle = flag;
      this.driverprocesstoggle = !this.driverusertoggle;
      this._puserid = -1;
    }
    if (momStr == 'process') {
      this.driverprocesstoggle = flag;
      this.driverusertoggle = !this.driverprocesstoggle
      this.driveruserpass = {
        clientid: -1,
        driverid: -1,
        id: -1,
        param: null,
        password: '',
        username: '',
        passwordorg: '',
        usernameorg: ''
      }
    }
    // console.log('username ' + this.driveruserpass.username)
    // console.log('puserid ' + this._puserid)

  }


  ionViewDidLoad() {
    this.authemployees()
    this.authemployeesleft()
    this.addvehicleid()
    this.addclubcards()
    this.driverclubcardsforshow()
    this.getPermisionsVehicles()
  }

  getPermisionsVehicles() {
    var _that = this
    this.gn._Post('/api/gn/getpermisionsvehicles', { did: this.gn.crypt(this.DriverId) }, function (_data) {


      for (let i = 0; i < _data.length; i++) {
        _data[i].begining = _data[i].begining != null ? moment(_data[i].begining).format('DD-MM-YYYY') : "/";
        _data[i].ending = _data[i].ending != null ? moment(_data[i].ending).format('DD-MM-YYYY') : "/"

      }
      _that.permisionvehicle = _data
    })
  }


  EditPerm(p: any) {
    var _that = this
    let modal = this.modalCtrl.create(PopupaddvehiclePage, {
      driverid: _that.DriverId, obj: p, cb: function () {
        _that.getPermisionsVehicles();
      }
    });
    modal.present();
  }

  DeletePerm(permid, idx) {
    var _that = this;
    this.permisionvehicle.splice(idx, 1);
    var dat = {
      permid: this.gn.crypt(permid),
      driverid: this.gn.crypt(this.DriverId)
    }
    _that.gn.loadWaiting();
    this.gn._Post('/api/gn/deletedrivervehicledate', dat, function (_data) {
      _that.gn.loaderWaiting.dismiss();
    })

  }

  // startDateA: any = new Date()
  // startDateStrA: any = moment(new Date()).format(this.gn.user.DFormat)

  openDatePopup(_ev, _startend) {
    var _that = this;

    var tmpd;
    if (_startend == 's')
      tmpd = this._borndateDT;
    if (_startend == 'ad')
      tmpd = this._firstlicenseDateDT;
    if (_startend == 'fl')
      tmpd = this._DriverslicenseexpirationDateDT;
    if (_startend == 'st')
      tmpd = this._startincompanyDateDT;

    let popover = this.popoverCtrl.create(CalendarPage, {
      d: tmpd, cb: function (d) {

        if (_startend == 's') {
          _that._borndateDT = d;
          _that._bornDate = moment(_that._borndateDT).format(_that.gn.user.DFormat)
        }
        if (_startend == 'ad') {
          _that._firstlicenseDateDT = d;
          _that._firstlicenseDate = moment(_that._firstlicenseDateDT).format(_that.gn.user.DFormat)
        }
        if (_startend == 'fl') {
          _that._DriverslicenseexpirationDateDT = d;
          _that._DriverslicenseexpirationDate = moment(_that._DriverslicenseexpirationDateDT).format(_that.gn.user.DFormat)
        }
        if (_startend == 'st') {
          _that._startincompanyDateDT = d;
          _that._startincompanyDate = moment(_that._startincompanyDateDT).format(_that.gn.user.DFormat)
        }
        // if (_startend == 'ad') {
        //   _that._firstlicenseDate = d;
        //   _that._firstlicenseDateStr = moment(_that._firstlicenseDate).format(_that.gn.user.DFormat)
        //   _that._firstlicenseDateYMD = moment(_that._firstlicenseDate).format('YYYY-MM-DD')
        // }
        // if (_startend == 'fl') {
        //   _that._DriverslicenseexpirationDate = d;
        //   _that._DriverslicenseexpirationDateStr = moment(_that._DriverslicenseexpirationDate).format(_that.gn.user.DFormat)
        //   _that._DriverslicenseexpirationDateYMD = moment(_that._DriverslicenseexpirationDate).format('YYYY-MM-DD')
        // }
        // if (_startend == 'st') {
        //   _that._startincompanyDate = d;
        //   _that._startincompanyDateStr = moment(_that._startincompanyDate).format(_that.gn.user.DFormat)
        //   _that._startincompanyDateYMD = moment(_that._startincompanyDate).format('YYYY-MM-DD')
        // }

      }
    })
    popover.present({ ev: _ev });

  }
  authemployees() {
    var _that = this
    this.gn._Post('/api/gn/authemployees', { did: this.gn.crypt(this.DriverId), cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      //debugger
      _that.authemployeess = _data
      // console.log('bosko',_data)
    })
  }

  authemployeesleft() {
    var _that = this
    this.gn._Post('/api/gn/authemployeesleft', { did: this.gn.crypt(this.DriverId), cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _that.authemployeessleft = _data
      // _that.gn.loaderWaiting.dismiss();
      // console.log('bosko',_data)

    })
  }
  refreshAuthEmplWhenDeleteVeh() {

    var _that = this
    this.gn._Post('/api/gn/authemployeesleft', { did: this.gn.crypt(this.DriverId), cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _that.authemployeessleft = _data
      _that.gn.loaderWaiting.dismiss();
      // console.log('bosko',_data)

    })

  }

  toggleDriverData() {
    var _that = this
    setTimeout(() => {
      if (_that.driveruserpass.username == _that.gn.user.username) {
        _that.driveruserpass.username = _that.driveruserpass.usernameorg
        _that.driveruserpass.password = _that.driveruserpass.passwordorg
      }
    }, 1000);
  }

  driveruser() {
    var _that = this

    this.gn._Post('/api/gn/driveruser', { did: this.gn.crypt(this.DriverId), cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      // _that.driveruserpass = _data[0]
      if (_data[0] != undefined) {
        _that.driveruserpass.username = _data[0].username;
        _that.driveruserpass.password = _data[0].password;

        _that.driveruserpass.usernameorg = _data[0].username;
        _that.driveruserpass.passwordorg = _data[0].password;

        _that.driveruserpass.clientid = _data[0].clientid;
        _that.driveruserpass.driverid = _data[0].driverid;
        _that.driveruserpass.id = _data[0].id;
      }

      // console.log(_that.driveruserpass);
      // console.log('bosko za pobeda', _data)
    })
  }

  addvehicleid() {
    var _that = this
    this.gn._Post('/api/gn/getvehiclesid', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _that.vehiclesid = _data
      // console.log('kocev bosko',_data)
    })
  }


  addVehicles1() {
    var _that = this
    let alert = this.alertCtrl.create(

    );
    alert.setTitle(this.dic.l["addauthorisedvehicle"]);
    for (var i = 0; i < this.vehiclesid.length; i++) {
      var ch = false
      for (var j = 0; j < this.vehiclesid.length; j++) {
        if (this.vehiclesid[j].driverid == this.vehiclesid[i].id) {
          ch = true
          break
        }
      }
      alert.addInput({

        type: 'checkbox',
        label: '(' + this.vehiclesid[i].registration + ') ' + this.vehiclesid[i].model,
        value: this.vehiclesid[i].id,
        checked: ch
      });
    }

    alert.addButton(this.dic.l["cancel"]);
    alert.addButton({
      text: this.dic.l["ok"],
      handler: data => {

        // _that.add2Drivers(data)

      }
    });
    alert.present();
  }



  Openpopupaddvehicle() {
    var _that = this
    let modal = this.modalCtrl.create(PopupaddvehiclePage, {
      driverid: _that.DriverId, obj: -1, cb: function () {
        _that.getPermisionsVehicles();
      }
    });
    modal.present();
  }


  addDriver() {

    // this.authemployeesleft();
    // console.log(this.authemployeessleft)
    var _that = this
    if (this.authemployeessleft.length == 0) {
      let alert = this.alertCtrl.create({
        title: this.dic.l["addauthorisedvehicle"],
        subTitle: this.dic.l['allvehchoosen'],
        buttons: [this.dic.l["ok"]]
      });
      alert.present();
    }
    else {
      let alert = this.alertCtrl.create();
      alert.setTitle(this.dic.l["addauthorisedvehicle"]);

      var ch = false
      alert.addInput({
        type: 'checkbox',
        label: this.dic.l["All"],
        value: '0',
        checked: ch,
        handler: (data) => {
          if (data.value + '' == '0') {
            if (this.authemployeessleft.length > 0) {
              for (let i = 1; i < alert['instance']['d']['inputs'].length; i++) {
                alert['instance']['d']['inputs'][i]['checked'] = alert['instance']['d']['inputs'][0]['checked']
              }
            }
          }
        }
      })

      for (var i = 0; i < this.authemployeessleft.length; i++) {
        var ch = false
        for (var j = 0; j < this.authemployeess.length; j++) {
          if (this.authemployeess[j].id == this.authemployeessleft[i].id) {
            ch = true
            break
          }
        }
        alert.addInput({
          type: 'checkbox',
          label: '(' + this.authemployeessleft[i].registration + ') ' + this.authemployeessleft[i].model,
          value: this.authemployeessleft[i].id,
          checked: ch
        });
      }


      alert.addButton(this.dic.l["cancel"]);
      alert.addButton({
        text: this.dic.l["ok"],
        handler: data => {
          //  _that.add2Drivers(data)
          console.log(data)

          _that.gn.loadWaiting();
          for (let i = 0; i < data.length; i++) {
            if (data[i] + '' != '0') {
              _that.gn._Post('/api/gn/setauthorizedvehicleondriver',
                {
                  vehid: _that.gn.crypt(data[i]),
                  did: _that.gn.crypt(_that.DriverId)
                }, function (_data) {
                  _that.authemployeess.push(_that.gn.Vehicles[_that.gn.VehiclesDic[data[i]]]);
                  _that.authemployeessleft = []
                  _that.authemployeesleft();
                  if (i == data.length - 1) {
                    _that.gn.loaderWaiting.dismiss();
                  }
                })




            }
          }

        }

      });
      alert.present();
    }
  }

  addDriver2() {

    // this.authemployeesleft();
    // console.log(this.authemployeessleft)
    var _that = this
    if (this.authemployeessleft.length == 0) {
      let alert = this.alertCtrl.create({
        title: this.dic.l["addauthorisedvehicle"],
        subTitle: this.dic.l['allvehchoosen'],
        buttons: [this.dic.l["ok"]]
      });
      alert.present();
    }
    else {

      var _that = this
      let modal = this.modalCtrl.create(EmployeevehPage, {
        authemp: this.authemployeessleft, driverid: this.DriverId, cb: function (vehicles) {

          if (vehicles.length > 0) {
            var jj = vehicles.length
            while (jj--) {
              for (let cc = 0; cc < _that.authemployeessleft.length; cc++) {
                if (vehicles[jj] == _that.authemployeessleft[cc].id) {
                  _that.authemployeess.push(_that.authemployeessleft[cc])
                  _that.authemployeessleft.splice(cc, 1);
                  vehicles.splice(jj, 1);
                }
              }
            }
          }
        }
      });
      modal.present();
    }
  }

  deleteAuthorizedVehcile(idx: number, _vehid: number) {
    var _that = this;
    this.authemployeess.splice(idx, 1);
    var dat = {
      vehid: this.gn.crypt(_vehid),
      did: this.gn.crypt(this.DriverId)
    }
    _that.gn.loadWaiting();
    this.gn._Post('/api/gn/deleteauthorizedvehicledriver', dat, function (_data) {
      _that.authemployeessleft = []
      _that.refreshAuthEmplWhenDeleteVeh();
    })
  }

  // addDriver() {

  //   // this.authemployeesleft();
  //   var _that = this
  //   let alert = this.alertCtrl.create();
  //   alert.setTitle(this.dic.l["addauthorisedvehicle"]);

  //   for (var i = 0; i < this.authemployeessleft.length; i++) {
  //     var ch = false
  //     for (var j = 0; j < this.authemployeess.length; j++) {
  //       if (this.authemployeess[j].id == this.authemployeessleft[i].id) {
  //         ch = true
  //         break
  //       }
  //     }
  //     alert.addInput({
  //       type: 'checkbox',
  //       label: '(' + this.authemployeessleft[i].registration + ') ' + this.authemployeessleft[i].model,
  //       value: this.authemployeessleft[i].id,
  //       checked: ch
  //     });
  //   }

  Addclubcards1() {
    var _that = this
    if (this.clubcardsleft.length == 0) {
      let alert = this.alertCtrl.create({
        title: this.dic.l["addcard"],
        subTitle: this.dic.l['allcardshoosen'],
        buttons: [this.dic.l["ok"]]
      });
      alert.present();
    }
    else {
      let alert = this.alertCtrl.create();
      alert.setTitle(this.dic.l["addcard"]);

      for (var i = 0; i < this.clubcardsleft.length; i++) {
        var ch = false
        for (var j = 0; j < this.clubcardsforshow.length; j++) {
          if (this.clubcardsforshow[j].id == this.clubcardsleft[i].id) {
            ch = true
            break
          }
        }
        alert.addInput({
          type: 'checkbox',
          label: this.clubcardsleft[i].cardname,
          value: this.clubcardsleft[i].id,
          checked: ch
        });

      }
      // console.log(this.clubcardsleft, this.clubcardsforshow)

      alert.addButton(this.dic.l["cancel"]);
      alert.addButton({
        text: this.dic.l["ok"],
        handler: data => {
          //  _that.add2Drivers(data)
          //  console.log(data)

          for (let i = 0; i < data.length; i++) {
            for (let j = 0; j < _that.clubcardsleft.length; j++) {
              // console.log("DODAVA VO LISTA ZA PRIKAZHUVANJE KARTICHKI");
              // console.log(_that.clubcardsleft[i].id, data[i]);
              if (_that.clubcardsleft[j].id == data[i]) {
                _that.clubcardsforshow.push(_that.clubcardsleft[j])
              }
            }
            _that.gn._Post('/api/gn/addclubcardstodrivers',
              {
                cardid: _that.gn.crypt(data[i]),
                did: _that.gn.crypt(_that.DriverId)
              }, function (_data) {

                _that.clubcardsleft = []
                _that.addclubcards();

              })


          }

        }
      });
      alert.present();
    }
  }





  deleteclubcards(idx: number, _cardid: number) {
    var _that = this;
    // var cardid = _cardid;
    var dat = {
      cardid: _that.gn.crypt(_cardid),
      did: _that.gn.crypt(_that.DriverId)
    }
    // _that.authemployeess.splice(idx,1);
    _that.clubcardsforshow.splice(idx, 1);
    // console.log(_that.DriverId, _cardid)
    _that.gn.loadWaiting();
    this.gn._Post('/api/gn/deleteclubcards', dat, function (_data) {
      _that.clubcardsleft = []
      _that.refreshclubcardsleft()

    })
  }


  addclubcards() {
    var _that = this
    this.gn._Post('/api/gn/getclubcardswhichleft', { did: this.gn.crypt(this.DriverId), cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _that.clubcardsleft = _data
      // console.log('club cards for show', _data)



      // _that.vehiclesid = _data
      // console.log('kocev bosko',_data)
    })
  }

  refreshclubcardsleft() {
    var _that = this
    this.gn._Post('/api/gn/getclubcardswhichleft', { did: this.gn.crypt(this.DriverId), cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _that.clubcardsleft = _data
      // console.log('club cards for show', _data)
      _that.gn.loaderWaiting.dismiss();


      // _that.vehiclesid = _data
      // console.log('kocev bosko',_data)
    })
  }


  driverclubcardsforshow() {
    var _that = this
    this.gn._Post('/api/gn/getclubcardsforshow', { did: this.gn.crypt(this.DriverId), cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _that.clubcardsforshow = _data

      // _that.vehiclesid = _data
      // console.log('kocev bosko',_data)
    })
  }






  Editemployees() {

    var _tf = this.checkForm();

    if (!_tf)
      return false;

    if (this.driveruserpass.username == '' && this.driveruserpass.password != '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["pleaseneteruser"], duration: 3000, position: 'top' });
      toast.present();
      return
    }

    if (this.driveruserpass.username != '' && this.driveruserpass.password == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["pleaseenterpassword"], duration: 3000, position: 'top' });
      toast.present();
      return
    }


    // if ((this.driveruserpass.username == '' && this.driveruserpass.password != '') || (this.driveruserpass.username != '' && this.driveruserpass.password == '')) {
    //   let toast = this.toastCtrl.create({ message: this.dic.l["pleasenterusernamepass"], duration: 3000, position: 'top' });
    //   toast.present();
    //   return
    // }

    var _authemployees = []
    for (var i = 0; i < this.authemployeesleft.length; i++) {
      _authemployees.push(this.authemployeessleft[i].driverid)
    }

    var _that = this
    // console.log(this.typelicenceA, this.typelicenceB, this.typelicenceC, this.typelicenceD, this.typelicenceE)
    var typelicencearr = [];
    if (this.typelicenceA == true) {
      typelicencearr.push('A');
    }
    if (this.typelicenceB == true) {
      typelicencearr.push('B');
    }
    if (this.typelicenceC == true) {
      typelicencearr.push('C');
    }
    if (this.typelicenceD == true) {
      typelicencearr.push('D');
    }
    if (this.typelicenceE == true) {
      typelicencearr.push('E');
    }

    // console.log(typelicencearr.join(','));

    // var _that = this

    //treba da se pravi promena na username i pass
    if (_that.driverdata) {
      if (_that.driveruserpass.username == _that.gn.user.username) {
        _that.driveruserpass.username = _that.driveruserpass.usernameorg
        _that.driveruserpass.password = _that.driveruserpass.passwordorg
      }
    } else {
      _that.driveruserpass.username = _that.driveruserpass.usernameorg
      _that.driveruserpass.password = _that.driveruserpass.passwordorg
    }

    var _dat = {

      fullname: this.gn.crypt(this._fullname),
      borndate: this.gn.crypt(moment(this._borndateDT).format('YYYY-MM-DD')),


      gender: this.maletoggle == true ? this.gn.crypt('M') : this.gn.crypt('F'),
      code: this.gn.crypt(this._code),
      startincompany: this.gn.crypt(moment(this._startincompanyDateDT).format('YYYY-MM-DD')),
      jobcontract: this.gn.crypt(this._jobcontract),
      rfid: this.gn.crypt(this._rfid),
      licensetype: this.gn.crypt(typelicencearr.join(',')),
      firstlicense: this.gn.crypt(moment(this._firstlicenseDateDT).format('YYYY-MM-DD')),
      licenseexp: this.gn.crypt(moment(this._DriverslicenseexpirationDateDT).format('YYYY-MM-DD')),

      // otherlicense: this._otherlicense),
      organisationid: this.gn.crypt(this._ounit),
      indooruserid: this.gn.crypt(this._puserid),
      // interlicenseexp: this.sadsdasa),
      interlicense: this.interlicencetoggle == true ? this.gn.crypt('1') : this.gn.crypt('0'),
      dlnumber: this.gn.crypt(this._DLNumber),
      did: this.gn.crypt(this.DriverId),
      cid: this.gn.crypt(this.gn.user.ClientId),
      allowdriverasuser: this.gn.crypt(this.gn.clientsettings.allowdriverasuser),

      // firstregistration: this.gn.crypt(moment(this._firstregistrationDT).format('YYYY-MM-DD')),

      driverid: this.gn.crypt(this.DriverId),

      username: (this.gn.clientsettings.allowdriverasuser == '1' && _that.driveruserpass.username != '') ? this.gn.crypt(_that.driveruserpass.username) : this.gn.crypt('-1'),
      password: (this.gn.clientsettings.allowdriverasuser == '1' && _that.driveruserpass.password != '') ? this.gn.crypt(_that.driveruserpass.password) : this.gn.crypt('-1')
    }
    // console.log(_dat)
    // var _that = this
    _that.gn.loadWaiting();
    this.gn._Post('/api/gn/editemployees', _dat, function (_data) {
      // _that.navCtrl.pop()
      _that.gn.loaderWaiting.dismiss();
      console.log(_data.newuserid, '_data.msg')
      if (_data.msg == 'error') {
        _that.gn.tfBtn = false;
        let toast = _that.toastCtrl.create({ message: _that.dic.l["usinfo06"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
      if (_data.newuserid != -1) {
        console.log('si vlegol tuka za alertite,zZ bosko vo edit employees')
        _that.gn._Post('/api/gn/updatealarmall', {
          cid: _that.gn.crypt(_that.gn.user.ClientId),
          rid: _that.gn.crypt(_that.gn.user.RoleId),
          uid: _that.gn.crypt(_data.newuserid)
        }, function (_data2) {
          if (_data2.msg == 'OK') {
            // _that.gn.getNotifications();
            // _that.navCtrl.pop()
            _that.gn.getNotifications();
          }
        })
      }
      var _cb = _that.navParams.get('cb')
      _cb()
      _that.navCtrl.pop()
    })
  }

  checkForm() {
    if (this._fullname == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["enterfullname"], duration: 3000, position: 'top' });
      toast.present();
      return false;
    }
    if (this.gn.clientsettings.allowdriverasuser == '1') {
      if (this.driveruserpass.username == '' && this.driveruserpass.password.length > 0) {
        let toast = this.toastCtrl.create({ message: this.dic.l["enterusername"], duration: 3000, position: 'top' });
        toast.present();
        return false;
      }
      if (this.driveruserpass.password == '' && this.driveruserpass.username.length > 0) {
        let toast = this.toastCtrl.create({ message: this.dic.l["enterpassword"], duration: 3000, position: 'top' });
        toast.present();
        return false;
      }
      var i = /^(?=.*[@$!%*#?&])/;
      //var re = /(?=.*[A-Z])/;
      var re = /^(?=.*[A-Z])/;
      if (this.driveruserpass.password.length < 6 && this.driveruserpass.username.length > 0) {
        let toast = this.toastCtrl.create({ message: this.dic.l["enterpasswordsixch"], duration: 3000, position: 'top' });
        toast.present();
        return false;
      }
      if (!i.test(this.driveruserpass.password) && this.driveruserpass.username.length > 0) {
        let toast = this.toastCtrl.create({ message: this.dic.l["enterpasswordspecch"], duration: 3000, position: 'top' });
        toast.present();
        return false;
      }
      if (!re.test(this.driveruserpass.password) && this.driveruserpass.username.length > 0) {
        let toast = this.toastCtrl.create({ message: this.dic.l["enterpasswordupper"], duration: 3000, position: 'top' });
        toast.present();
        return false;
      }
    }
    return true;
  }

  addnewemplyees() {
    // if (_data.errorcode == '1') {
    //   let toast = _that.toastCtrl.create({ message: _that.dic.l["usinfo06"], duration: 3000, position: 'top' });
    //   toast.present();
    //   return
    // }


    var _tf = this.checkForm();

    if (!_tf)
      return false;

    // if ((this.driveruserpass.username == '' && this.driveruserpass.password != '') || (this.driveruserpass.username != '' && this.driveruserpass.password == '')) {
    //   let toast = this.toastCtrl.create({ message: this.dic.l["pleasenterusernamepass"], duration: 3000, position: 'top' });
    //   toast.present();
    //   return
    // }

    if (this.driveruserpass.username == '' && this.driveruserpass.password != '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["pleaseneteruser"], duration: 3000, position: 'top' });
      toast.present();
      return
    }

    if (this.driveruserpass.username != '' && this.driveruserpass.password == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["pleaseenterpassword"], duration: 3000, position: 'top' });
      toast.present();
      return
    }


    // console.log(this.typelicenceA, this.typelicenceB, this.typelicenceC, this.typelicenceD, this.typelicenceE)
    var typelicencearr = [];
    if (this.typelicenceA == true) {
      typelicencearr.push('A');
    }
    if (this.typelicenceB == true) {
      typelicencearr.push('B');
    }
    if (this.typelicenceC == true) {
      typelicencearr.push('C');
    }
    if (this.typelicenceD == true) {
      typelicencearr.push('D');
    }
    if (this.typelicenceE == true) {
      typelicencearr.push('E');
    }

    // console.log(typelicencearr.join(','));


    var _dat = {

      fullname: this.gn.crypt(this._fullname),
      borndate: this.gn.crypt(moment(this._borndateDT).format('YYYY-MM-DD')),


      gender: this.maletoggle == true ? this.gn.crypt('M') : this.gn.crypt('F'),
      code: this.gn.crypt(this._code),
      startincompany: this.gn.crypt(moment(this._startincompanyDateDT).format('YYYY-MM-DD')),
      jobcontract: this.gn.crypt(this._jobcontract),
      rfid: this.gn.crypt(this._rfid),
      licensetype: this.gn.crypt(typelicencearr.join(',')),
      firstlicense: this.gn.crypt(moment(this._firstlicenseDateDT).format('YYYY-MM-DD')),
      licenseexp: this.gn.crypt(moment(this._DriverslicenseexpirationDateDT).format('YYYY-MM-DD')),

      // otherlicense: this._otherlicense,
      organisationid: this.gn.crypt(this._ounit),
      indooruserid: this.gn.crypt(this._puserid),
      // interlicenseexp: this.sadsdasa,
      interlicense: this.interlicencetoggle == true ? this.gn.crypt('1') : this.gn.crypt('0'),
      dlnumber: this.gn.crypt(this._DLNumber),
      // did: this.DriverId,



      driverid: this.gn.crypt(this.DriverId),
      clientid: this.gn.crypt(this.gn.user.ClientId),

      username: (this.gn.clientsettings.allowdriverasuser == '1' && this.driveruserpass.username != '') ? this.gn.crypt(this.driveruserpass.username) : this.gn.crypt('-1'),
      password: (this.gn.clientsettings.allowdriverasuser == '1' && this.driveruserpass.password != '') ? this.gn.crypt(this.driveruserpass.password) : this.gn.crypt('-1')
    }

    this.gn.loadWaiting();
    // console.log(_dat);
    //this.gn.disableBtn();
    this.gn.tfBtn = true;
    var _that = this
    this.gn._Post('/api/gn/createemployees', _dat, function (_data) {
      console.log(_data, 'daj da vidam data')
      var userid = _data.newuserid

      // _that.navCtrl.pop()
      _that.gn.loaderWaiting.dismiss();
      if (_data.msg == 'error') {
        _that.gn.tfBtn = false;
        let toast = _that.toastCtrl.create({ message: _that.dic.l["usinfo06"], duration: 3000, position: 'top' });
        toast.present();
        return

      }

      if (_data.newuserid != -1) {
        console.log('si vlegol tuka za alertite,zZ bosko vo add employees')
        _that.gn._Post('/api/gn/updatealarmall', {
          cid: _that.gn.crypt(_that.gn.user.ClientId),
          rid: _that.gn.crypt(_that.gn.user.RoleId),
          uid: _that.gn.crypt(_data.newuserid)
        }, function (_data2) {
          if (_data2.msg == 'OK') {
            // _that.gn.getNotifications();
            // _that.navCtrl.pop()
            _that.gn.getNotifications();
          }
        })
      }

      var _cb = _that.navParams.get('cb')
      _cb()
      _that.navCtrl.pop()
      //_that.gn.enableBtn();
      _that.gn.tfBtn = false;
    })
  }

  // Addnewcardtodriver(){
  //   var _that = this

  //   var _dat = {
  //     did: this.gn.crypt(this.DriverId),
  //     cardid: this.gn.crypt(this.clubcards.id),
  //   }


  //   this.gn._Post('/api/gn/addclubcardstodrivers', _dat, function(_data){
  //     // _that.navCtrl.pop()
  //     var _cb = _that.navParams.get('cb')
  //     _cb()
  //     _that.navCtrl.pop()
  //   })

  // }




}






// WEBPACK FOOTER //
// ./src/pages/settings/driversettings/driversedit.ts